// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7fa99377","453":"ab4e7938","455":"732f18d1","977":"7cf161ad"}[chunkId] + ".chunk.js";
};